module.exports = __webpack_public_path__ + "dash_20_app_assets/img/pgfbl.45e3d35e.png";